import { useState } from 'react';
import { userErrorMessage } from '../api/errors.js';
import { useI18n } from '../i18n/context.js';

export function useActionFeedback(): {
  readonly pending: boolean;
  readonly error: string | null;
  run(action: Promise<unknown>): void;
} {
  const { t } = useI18n();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return {
    pending,
    error,
    run(action) {
      setPending(true);
      setError(null);
      void action
        .catch((reason: unknown) => setError(userErrorMessage(reason, t)))
        .finally(() => setPending(false));
    },
  };
}
